import { Layer, Rect } from 'react-konva';
import { getVisibleSelectionAreas } from '../../../helpers/selectionHelper';
import { ReturnTypeofSheetSectionsSelector } from '../../../selectors/sheetUiSelector';
import { convertPositionToArea } from '../../../utils/area/area';
import { UseSheetTheme } from '../../../hooks/useSheetTheme';

interface ActiveCellProps
  extends ReturnTypeofSheetSectionsSelector,
    Pick<UseSheetTheme, 'isRtl' | 'selectionBorder'> {
  stageWidth: number;
}
const ActiveCell: React.FC<ActiveCellProps> = (props) => {
  const area = getVisibleSelectionAreas(
    props,
    props.activeCellArea,
    props.stageWidth,
    props.isRtl
  )[0];

  if (!area) return null;
  const { width, height, x, y } = area;
  if (width === 0 || height === 0) return null;

  return (
    <Rect
      x={x}
      width={width}
      height={height}
      y={y}
      fill="transparent"
      stroke={props.selectionBorder}
      strokeWidth={1.5}
      listening={false}
    />
  );
};

export default ActiveCell;
